import { Box, SxProps, Typography } from "@mui/material";
import PageIcon from "components/layout/menu/PageIcon";
import React, { FunctionComponent } from "react";
import { MenuItem } from "stores/mainMenu/types";
import { getHeaderTitleByPageId } from "stores/route/utils/pagesId";
import palette from "styles/palette";
import ParentMenu from "./ParentMenu";



const isPLC = import.meta.env.VITE_TARGET == "plc"

interface Props {
	item: MenuItem,
	onClickIcon?: () => void
}

const ParentItem: FunctionComponent<Props> = ({
	item,
	onClickIcon,
}) => {

	// STORE

	// HOOKs

	// ricava i dati da visualizzare
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	// HANDLERS
	const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	}
	const handleCloseMenu = () => {
		setAnchorEl(null);
	}

	// RENDER
	const title = getHeaderTitleByPageId(item.id)
	if ( !title) return null
	const open = Boolean(anchorEl)

	return <>
	
		<Box sx={sxContainer}>

			<PageIcon sx={{ cursor: "pointer" }}
				pageId={item.id} 
				onClick={onClickIcon}  
			/>
			
			<Typography variant="h5" sx={sxLabel}
				onClick={handleOpenMenu}
			>
				{title}
			</Typography>
			
		</Box>

		<ParentMenu
			anchorEl={anchorEl}
			open={open}
			onClose={handleCloseMenu}
			item={item} 
		/>

	</>
}

export default ParentItem

const sxContainer: SxProps = {
	display: "flex",
	alignItems: "center",
	fill: palette.text.primary,
}
const sxLabel:SxProps = {
	m: "0px 7px 0px 5px",
	cursor: "pointer",
}